import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-none",
  "use": "icon-status-none-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status-none\">\n<circle cx=\"8\" cy=\"8\" r=\"5\" fill=\"#677690\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol